ChangeBoardPermsView = require 'views/board-menu/change-board-perms-view'

module.exports = class ChangeBoardCommentingPermsView extends ChangeBoardPermsView
  viewTitleKey: 'commenting permissions'
  getTemplate: -> 'board_menu_commenting'
  getPerm: -> 'comments'



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/change-board-commenting-perms-view.coffee